export default {
    text1: '开户领取奖励',
    text2: '前往星财富',
    text3: '复星财富 x MyLink独家礼遇',
    text4: '领取成功',
    text5: '领取失败',
    text6: '活动不存在',
    text7: '活动不为发布状态',
    text8: 'uin不存在',
    text9: '用户不存在',
    text10: '已经领取过',
    text11: '此活动不适用于阁下之账户',
}
